<template>
  <modal id="galleryEditModal">
    <template slot="header">
      <button type="button" class="close close-popup desktop-only" @click.prevent="cancelEdit()">
        <span aria-hidden="true">×</span>
      </button>
      <a
        class="close mobile-only"
        data-dismiss="modal"
        aria-label="Close">
        Cancel
      </a>
      <h2 class="modal-title">Edit Gallery Project</h2>
    </template>

    <div class="alert alert-danger color-error msgblock" v-if="formErrors">
      <span v-for="(message,index) in formError" :key="index">
        {{ message }}<br v-if="index < formError.length - 1">
      </span>
    </div>
    <div class="alert alert-success msgblock" v-if="formSuccess">
      {{ formSuccess}}
    </div>

    <form enctype="multipart/form-data" id="profile-edit-form" v-if="edit.id !== null && edit.id !== undefined && edit.approval_type !== 'needs_review'">
      <div class="panel-group" id="accordionEditor">
        <div class="panel form-group keyword-group">
          <a class="" data-toggle="collapse" data-parent="#accordionEditor"
            href="#collapseEditKeywords">
            <i class="hashtag"></i>&nbsp;
            <label>Step 1: Keywords</label>&nbsp;&nbsp;
            <i aria-hidden="true" class="fa fa-angle-right"></i>
          </a>
          <div id="collapseEditKeywords" class="panel-collapse collapse in col-sm-12">
            <p>
              <i>Add Keywords to help people find your project</i>
            </p>
            <div class="row">
              <div class="col-sm-6">
                <span class="styled-select icon-angle">
                  <vToken2
                    v-model="categoryHashtags"
                    id="categories"
                    :options="this.categorySearchOptions">
                </vToken2>
                </span>
              </div>
              <div class="col-sm-6">
                <span class="styled-select icon-angle">
                  <vToken2
                    v-model="typeHashtags"
                    id="types"
                    :options="this.typeSearchOptions">
                  </vToken2>
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <span class="styled-select icon-search">
                  <vToken2
                    v-model="makeHashtags"
                    id="makes"
                    :options="this.makeSearchOptions">
                  </vToken2>
                </span>
              </div>
              <div class="col-sm-6">
                <span class="styled-select icon-search">
                  <vToken2
                    v-model="modelHashtags"
                    id="models"
                    :options="this.modelSearchOptions">
                  </vToken2>
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <span class="styled-select icon-search">
                  <vToken2
                    v-model="otherHashtags"
                    id="keywords"
                    :options="this.keywordSearchOptions">
                  </vToken2>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="panel form-group color-group" :class="{ 'has-error': errors.has('color_product_ids') }">
          <a class="collapsed" data-toggle="collapse" data-parent="#accordionEditor"
            href="#collapseEditColors">
            <i class="fa fa-paint-brush"></i>&nbsp;
            <label>Step 2: Colors Used</label>&nbsp;&nbsp;
            <i aria-hidden="true" class="fa fa-angle-right"></i>
          </a>
          <div id="collapseEditColors" class="panel-collapse collapse col-sm-12">
            <span class="colorItem" v-for="color in project.colors"><a v-on:click.prevent="removeColor(color)">x</a> {{color.name}}</span>
            <span class="styled-select icon-search">
              <vToken2
                  v-model="chosenEditProjectColors"
                  name="color_product_ids"
                  :options="projectColorSearchOptions">
                <span slot="no-options">No Match Found</span>
              </vToken2>
            </span>
          </div>
        </div>
      </div>

      <div class="form-group">
        <span>Please upload images with 1280 x 1024 resolution</span>
        <div class="upload-file-edit"><label for="file-upload-edit" class="custom-file-upload-edit" v-if="!imageLoading">Select Images*</label>
                                      <label class="custom-file-upload-edit" v-if="imageLoading"><i class="fa fa-spin fa-spinner"></i></label>
          <input id="file-upload-edit" name="editImages" type="file" v-on:change="uploadEditFiles($event, edit)" class="form-control" accept="image/*" multiple>
          <div v-for="image in loadedImages" class="img-wrapper">
            <img :src="image.image_url">
            <span class="fa fa-times delete-image" @click.prevent="removeLoadedImage(image)"></span>
          </div>
        </div>
      </div>

      <div class="row" v-if="edit.description">
        <div class="col-sm-12">
          <div class="form-group">
            <label>Project Story</label>
            <p>{{ edit? edit.description : '' }}</p>
          </div>
        </div>
      </div>
      <div class="form-group text-right">
        <button
          class="btn btn-black"
          @click.prevent="cancelEdit()"
          style="font-size: 1.8rem;">
          Cancel
        </button>
        <button
            v-on:click.prevent="editProject(edit)"
            class="btn btn-orange"
            :disabled="errors.any() || processing">
          Save Changes <i class="fa fa-spin fa-spinner" v-show="processing"></i>
        </button>
      </div>
    </form>
  </modal>
</template>

<script>
  import vToken2 from '../global/Token2.vue'

  export default {
    components: {
      vToken2
    },

    data() {
      return {
          edit: {
            color_product_ids: [],
            keywords: []
          },
          project: {},
          chosenEditProjectColors: [],
          loading: false,
          loadedImages: [],
          storageEdit: {
            images: []
          },
          processing: false,
          formSuccess: null,
          formErrors: null,
          categoryHashtags: [],
          typeHashtags: [],
          makeHashtags: [],
          modelHashtags: [],
          otherHashtags: [],
          okCancelProject: {},
          okCancelElement: null,
          imageLoading: false,

          projectColorSearchOptions: {
            placeholder: "Enter SKUs or product names",
            maximumSelectionLength: 6,
            ajax: {
              url: '/api/proxify/domains/cerakote/shop/products?allcats=cera_all_colors&fields=id,name,sku',
              delay: 500,
              data(params) {
                return {
                  q: params.term
                }
              },
              processResults(data, params) {
                return {results: data.data};
              },
            },
            templateResult(item) {
              if (item.loading) {
                  return item.text;
              }
              return `${item.name}-${item.sku}`;
            },
            templateSelection(item) {
              return `${item.name}-${item.sku}`;
            }
          },

          categorySearchOptions: {
            placeholder: "Select or add a Category",
            minimumInputLength: 0,
            allowClear: false,
            ajax: {
              url: '/api/proxify/domains/cerakote/hashtag-types/37/hashtags?orderby=label&orderdir=asc',
              delay: 500,
              data(params) {
                return {
                  q: params.term
                }
              },
              processResults(data, params) {
                return {results: data.data};
              },
            },
            templateResult(item) {
              if (item.loading) {
                return item.text;
              }
              if (item.label) {
                return `<div class="hashtag">${item.label}</div>`;
              }
              return `<div class="hashtag">${item.text}</div>`;

            },
            templateSelection(item) {
              if (item.label) {
                return `<span class="${item.type}">${item.label}</span>`;
              }
              return `<span class="hashtag">${item.text}</span>`;
            }
          },

          typeSearchOptions: {
            placeholder: "Select or add a Type",
            minimumInputLength: 0,
            allowClear: false,
            ajax: {
              url: '/api/proxify/domains/cerakote/hashtag-types/36/hashtags?orderby=label&orderdir=asc',
              delay: 500,
              data(params) {
                return {
                  q: params.term
                }
              },
              processResults(data, params) {
                return {results: data.data};
              },
            },
            templateResult(item) {
              if (item.loading) {
                return item.text;
              }
              if (item.label) {
                return `<div class="hashtag">${item.label}</div>`;
              }
              return `<div class="hashtag">${item.text}</div>`;
            },
            templateSelection(item) {
              if (item.label) {
                return `<span class="${item.type}">${item.label}</span>`;
              }
              return `<span class="hashtag">${item.text}</span>`;
            }
          },

          makeSearchOptions: {
            placeholder: "Select or add a Make",
            minimumInputLength: 0,
            allowClear: false,
            ajax: {
              url: '/api/proxify/domains/cerakote/hashtag-types/35/hashtags?suggest_new=true&orderby=label&orderdir=asc',
              delay: 500,
              data(params) {
                return {
                  q: params.term
                }
              },
              processResults(data, params) {
                return {results: data.data};
              },
            },
            templateResult(item) {
              if (item.loading) {
                return item.text;
              }
              if (item.label) {
                return `<div class="hashtag">${item.label}</div>`;
              }
              return `<div class="hashtag">${item.text}</div>`;
            },
            templateSelection(item) {
              if (item.label) {
                return `<span class="${item.type}">${item.label}</span>`;
              }
              return `<span class="hashtag">${item.text}</span>`;
            }
          },

          modelSearchOptions: {
            placeholder: "Select or add a Model",
            minimumInputLength: 0,
            allowClear: false,
            ajax: {
              url: '/api/proxify/domains/cerakote/hashtag-types/38/hashtags?suggest_new=true&orderby=label&orderdir=asc',
              delay: 500,
              data(params) {
                return {
                  q: params.term
                }
              },
              processResults(data, params) {
                return {results: data.data};
              },
            },
            templateResult(item) {
              if (item.loading) {
                return item.text;
              }
              if (item.label) {
                return `<div class="hashtag">${item.label}</div>`;
              }
              return `<div class="hashtag">${item.text}</div>`;
            },
            templateSelection(item) {
              if (item.label) {
                return `<span class="${item.type}">${item.label}</span>`;
              }
              return `<span class="hashtag">${item.text}</span>`;
            }
          },

          keywordSearchOptions: {
            placeholder: "Add additional keywords",
            allowClear: false,
            ajax: {
              url: '/api/proxify/domains/cerakote/gallery-search/tokenizer?suggest_new=true',
              delay: 500,
              data(params) {
                return {
                  phrase: params.term,
                  type: 'hashtag'
                }
              },
              processResults(data, params) {
                return {results: data};
              },
            },
            templateResult(item) {
              if (item.loading) {
                  return item.text;
              }

              return `<div class="${item.type}">${item.label} - <span>${item.description}</span></div>`;
            },
            templateSelection(item) {
              if (item.label) {
                return `<span class="${item.type}">${item.label}</span>`;
              }
              return `<span class="hashtag">${item.text}</span>`;
            }
          }
        }
    },
    computed: {
      selectedEditColorIds() {
        return this.chosenEditProjectColors.map(color => color.id);
      },
      formError() {
        return this.formErrors.split('|');
      },
      editKeywords() {
        return this.edit.keywords.map(keyword => {
          if (keyword.label) {
            if (keyword.types) {
              return {label: keyword.label, id: keyword.id, types: keyword.types}
            }
            return {label: keyword.label, id: keyword.id}
          }
          return {label: keyword.text, id: keyword.id}
        })
      }
    },
    mounted() {
        let vm = this;
        window.appVariables.bus.$on('uploadGalleryImage', (okAction) => {vm.uploadEditFiles(vm.okCancelElement, vm.okCancelProject, okAction)});
        window.appVariables.bus.$on('removeGalleryImage', (okAction) => {vm.removeLoadedImage(vm.okCancelProject, okAction)});
        window.appVariables.bus.$on('cancelGalleryUpdate', (okAction) => {vm.cancelAction(okAction)});
    },
    methods: {
      cancelAction(okAction) {
          setTimeout(function(){ $('body').addClass('modal-open'); }, 500);
          this.okCancelProject = {};
          this.okCancelElement = okAction;
      },
      reloadEditModal(project) {
        for (let keyword of project.keywords) {
          if (keyword.types.length) {
            let hashtagTypes = _.map(keyword.types, 'label');
            if (hashtagTypes.includes('Category')) {
              this.categoryHashtags.push({
                label: keyword.label
              });
              setTimeout(function() {
                let newOption = new Option(keyword.label, keyword.id, true, true);
                $('#categories').append(newOption).trigger('change');
              }, 200);
            } else if (hashtagTypes.includes('Type')) {
              this.typeHashtags.push({
                label: keyword.label
              });
              setTimeout(function() {
                let newOption = new Option(keyword.label, keyword.id, true, true);
                $('#types').append(newOption).trigger('change');
              }, 200);
            } else if (hashtagTypes.includes('Make')) {
              this.makeHashtags.push({
                label: keyword.label
              });
              setTimeout(function() {
                let newOption = new Option(keyword.label, keyword.id, true, true);
                $('#makes').append(newOption).trigger('change');
              }, 200);
            } else if (hashtagTypes.includes('Model')) {
              this.modelHashtags.push({
                label: keyword.label
              });
              setTimeout(function() {
                let newOption = new Option(keyword.label, keyword.id, true, true);
                $('#models').append(newOption).trigger('change');
              }, 200);
            } else {
              this.otherHashtags.push({
                label: keyword.label
              });
              setTimeout(function() {
                let newOption = new Option(keyword.label, keyword.id, true, true);
                $('#keywords').append(newOption).trigger('change');
              }, 200);
            }
          } else {
            this.otherHashtags.push({
              label: keyword.label
            });
            setTimeout(function() {
              let newOption = new Option(keyword.label, keyword.id, true, true);
              $('#keywords').append(newOption).trigger('change');
            }, 200);
          }
        }
        this.edit = {};
        this.edit = Object.assign({}, project);
        this.project = Object.assign({}, project);
        this.edit.color_product_ids = [];
        this.edit.keywords = [];
        this.chosenEditProjectColors = [];
        this.processing = false;
        this.loading = false;
        this.loadedImages = [];
        this.storageEdit.images = [];
        this.formErrors = null;
        this.formSuccess = null;
        if (project.id === null || project.id === undefined || project.approval_type === 'needs_review') {
          this.formSuccess = 'Your Gallery Project Submitted For Review';
        }
        const projectId = project.id;
        axios({
          url: `/api/proxify/domains/cerakote/projects/${projectId}/media`,
          method: 'GET',
          params: { orderby: 'sort_index', orderdir: 'asc' }
        }).then(response => {
          this.loadedImages = response.data.data;
        })
        .catch(({response: error}) => {
          alert('could not load image to project');
        })
      },

      uploadEditFiles(e, project, okAction = false) {
        setTimeout(function(){ $('body').addClass('modal-open'); }, 500);
        let vm = this;
        if (!okAction) {
          vm.$root.lockedTitle = 'Project Modification';
          vm.$root.lockedMessage = `Changes to the images will immediately move the project into pending status until it has been reviewed.<br> Would you like to continue with these changes?`;
          vm.$root.okCancel = true;
          vm.$root.okCancelText = ['Yep', 'Nope'];
          vm.$root.okCancelAction = 'uploadGalleryImage';
          vm.okCancelProject = project;
          vm.okCancelElement = e;

          $('#informationModal').modal('show');
          return;
        }

        vm.imageLoading = true;
        const dataTarget = e.dataTransfer || e.target;
        const files = dataTarget.files;
        let images = [];
        let done = false;

        images = Array.from(files);

        for (const [index, image] of images.entries()) {
          let formData = new FormData();
          if (index === images.length - 1) {
            done = true;
          }

          formData.set('file', image);

          axios({
            url: `/api/proxify/domains/cerakote/projects/${project.id}/media/upload`,
            method: 'POST',
            data: formData
          }).then(response => {
            if (done) {
              axios({
                url: `/api/proxify/domains/cerakote/projects/${project.id}/media`,
                method: 'GET',
                params: { orderby: 'sort_index', orderdir: 'asc' }
              }).then(response2 => {
                this.loadedImages = response2.data.data;
                vm.imageLoading = false;
              }).catch(({response: error}) => {
                alert('could not load image to project');
                vm.imageLoading = false;
              })
            }
          }).catch(({response: error}) => {
            alert('could not add image to project');
            vm.imageLoading = false;
          })
        }
      },

      removeLoadedImage(image, okAction = false) {
        setTimeout(function(){ $('body').addClass('modal-open'); }, 500);
        let vm = this;
        if (!okAction) {
          vm.$root.lockedTitle = 'Project Modification';
          vm.$root.lockedMessage = `Changes to the images will immediately move the project into pending status until it has been reviewed.<br> Would you like to continue with these changes?`;
          vm.$root.okCancel = true;
          vm.$root.okCancelText = ['Yep', 'Nope'];
          vm.$root.okCancelAction = 'removeGalleryImage';
          vm.okCancelProject = image;

          $('#informationModal').modal('show');
          return;
        }

        let imageIndex = this.loadedImages.indexOf(image);
        const imageId = image.id;
        const projectId = this.edit.id;
        axios({
          url: `/api/proxify/domains/cerakote/projects/${projectId}/media/${imageId}`,
          method: 'DELETE',
          data: {}
        }).then(response => {
          this.loadedImages.splice(imageIndex, 1);
        }).catch(({response: error}) => {
          alert('could not remove image from project');
        })
      },

      removeColor(color) {
        let colorIndex = this.project.colors.indexOf(color);
        this.project.colors.splice(colorIndex, 1);
        this.project.color_product_ids.splice(colorIndex, 1);
      },

      async editProject(project) {
        let vm = this;
        if (vm.processing) {
          return false;
        }

        vm.formErrors = null;
        vm.processing = true;

        const projectId =  project.id;
        let projectData = {
            color_product_ids: []
        };

        for (let color of vm.chosenEditProjectColors) {
          projectData.color_product_ids.push(color.id);
        }

        for (let color of vm.project.colors) {
          projectData.color_product_ids.push(color.product_id);
        }

        projectData.keywords = [];

        vm.edit.keywords = vm.edit.keywords.concat(vm.categoryHashtags);
        vm.edit.keywords = vm.edit.keywords.concat(vm.typeHashtags);
        vm.edit.keywords = vm.edit.keywords.concat(vm.makeHashtags);
        vm.edit.keywords = vm.edit.keywords.concat(vm.modelHashtags);
        vm.edit.keywords = vm.edit.keywords.concat(vm.otherHashtags);

        projectData.keywords = vm.editKeywords;

        if (project.featured_image_url !== null){
          projectData.featured_image_url = project.featured_image_url;
        }

        let patchUrl = `/api/proxify/domains/cerakote/projects/${projectId}`;

        try {
            let response = await axios.patch(patchUrl, projectData);
            vm.formSuccess = 'Your Gallery Project has been Updated Successfully';
            vm.edit.approval_type = 'needs_review';
            vm.$emit('project-edited', response.data);
            $('#createModal').animate({
                scrollTop: ($('.modal-content').first().offset().top)
            },500);
            $('.modal .btn-orange').removeAttr('disabled');
            vm.processing = false;
            vm.$nextTick(() => {
                vm.errors.clear();
            });
        } catch (error) {
            console.error(error);
            $('.modal .btn-orange').removeAttr('disabled');
            vm.processing = false;
        }
      },
      cancelEdit() {
          this.edit = {
              color_product_ids: [],
              keywords: []
          };
          this.project = {};
          this.chosenEditProjectColors = [];
          this.loading = false;
          this.loadedImages = [];
          this.processing = false;
          this.formSuccess = null;
          this.formErrors = null;
          this.categoryHashtags = [];
          this.typeHashtags = [];
          this.makeHashtags = [];
          this.modelHashtags = [];
          this.otherHashtags = [];
          $('#galleryEditModal').modal('hide');
      }
    }
  }
</script>
